module.exports = __webpack_public_path__ + "media/images/list_practice/1-01-0e134a19ead27cd3e28569510fc714ee.svg";